export default __webpack_public_path__ + "static/media/trr-drink-bottle-crookedstavevon.47c69ef4.png";